import React from 'react';

const Footer: React.FC = () => null;

export default Footer;
